import React, { useContext } from 'react';
import { SideBar } from '@eposnow/ui-core';
import { Toolbar, useMediaQuery, useTheme } from '@mui/material';
import { DataGridConfigContext } from '../../context/DataGridConfigContext';
import { DataGridContext } from '../../context/DataGridContext';
import { UIContext } from '../../context/UIContext';
import { ADDRESS_DRAWER_WIDTH, XL_WIDTH, XL_WIDTH_AUTO_MARGIN } from '../../constants';

const CreateEditSidebar = <_T, TErrors>() => {
  const theme = useTheme();
  const { isMobile, animationsDisabled, iOS } = useContext(UIContext);
  const isLargeDeviceSwipeable = useMediaQuery(
    theme.breakpoints.up(
      XL_WIDTH + 2 * XL_WIDTH_AUTO_MARGIN + 20 // extra padding
    )
  );

  const { errorMessage, errors, setErrors, setErrorMessage, setSuccessMessage, CreateComponent } =
    useContext(DataGridConfigContext);

  const { isCreatingObject, objectBeingEdited, resetCurrentObjectAndNavigate } =
    useContext(DataGridContext);

  return (
    (isCreatingObject || objectBeingEdited) && (
      <SideBar
        open={isCreatingObject || objectBeingEdited != null}
        toggleDrawer={resetCurrentObjectAndNavigate}
        showSwipeableDrawer={!isMobile && !isLargeDeviceSwipeable}
        width={{
          drawerWidth: !isMobile ? ADDRESS_DRAWER_WIDTH : '100%',
          closedDrawerWidth: 0,
        }}
        anchor="right"
        belowTopBar={!isMobile}
        disableSwipe={!isMobile}
        iOS={iOS}
        animationsDisabled={animationsDisabled}
        theme={theme}
      >
        <>
          {!isMobile && <Toolbar />}
          <CreateComponent
            currentObject={isCreatingObject ? undefined : objectBeingEdited}
            resetObject={resetCurrentObjectAndNavigate}
            setSuccessMessage={setSuccessMessage}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            errors={errors as TErrors}
            setErrors={setErrors}
            mode={isCreatingObject ? 'create' : 'edit'}
          />
        </>
      </SideBar>
    )
  );
};

export default CreateEditSidebar;
